import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grow pr-4 flex flex-col gap-4" }
const _hoisted_2 = { class: "grow pl-4 border-l border-l-System/app_border" }


import { Maybe } from 'graphql/jsutils/Maybe';
import COLORS from '@/design-system/colors.json';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import WorkloadViewPerformancePieChart from './workload-view-performance-pie-chart.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-performance-build-cache',
  props: {
    chaceable: null,
    chaceablePercentage: null,
    uncacheable: null,
    uncacheablePercentage: null,
    hits: null,
    hitsPercentage: null,
    misses: null,
    missesPercentage: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-performance-build-cache flex flex-row place-content-stretch w-full" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(WorkloadViewPerformancePieChart, {
          sections: [
          {
            title: _ctx.$t('workloads.details.performanceMetricsTab.buildCache.cacheable'),
            value: __props.chaceable || 0,
            percentage: __props.chaceablePercentage || 0,
            color: _unref(COLORS)['System/app_secondary'],
            dataTestId: 'build-cache-cacheable',
          },
          {
            title: _ctx.$t('workloads.details.performanceMetricsTab.buildCache.uncacheable'),
            value: __props.uncacheable || 0,
            percentage: __props.uncacheablePercentage || 0,
            color: _unref(COLORS)['Text/text_medium'],
            dataTestId: 'build-cache-uncacheable',
          },
        ]
        }, null, 8, ["sections"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(WorkloadViewPerformancePieChart, {
          sections: [
          {
            title: _ctx.$t('workloads.details.performanceMetricsTab.buildCache.hits'),
            value: __props.hits || 0,
            percentage: __props.hitsPercentage || 0,
            color: _unref(COLORS)['System/app_secondary'],
            dataTestId: 'build-cache-hits',
          },
          {
            title: _ctx.$t('workloads.details.performanceMetricsTab.buildCache.misses'),
            value: __props.misses || 0,
            percentage: __props.missesPercentage || 0,
            color: _unref(COLORS)['Surface/surface_error_moderate'],
            dataTestId: 'build-cache-misses',
          },
        ]
        }, null, 8, ["sections"])
      ])
    ]),
    _: 1
  }))
}
}

})